export interface IQueryParams {
  query?: string;
  page?: number;
  limit?: number;
  sort?: string;
  order?: 'asc' | 'desc';
  searchKeys?: string[];
}

export enum QueryFilterType {
  STRING = 'string',
  DATE = 'date',
}

interface FilterDate {
  from: Date;
  to: Date;
}

interface FilterEqual {
  equal: string;
}

export interface QueryFilters {
  [key: string]: FilterDate | FilterEqual;
}

export class QueryParams {
  query?: string;
  page?: number;
  limit?: number;
  sort?: string;
  order?: 'asc' | 'desc';
  searchKeys?: string[];
  filters?: QueryFilters;

  constructor(query = '') {
    this.query = query;
    this.page = 1;
  }
}

export class PaginatedData<T> {
  data: T[] = [];
  currPage = 1;
  totalPages = 0;
  totalItems = 0;
}
